module.exports = __webpack_public_path__ + "img/sofa_vidro.1fd76091.png";